import { ReactComponent as Image } from './route-template-icon.svg';

export function RouteTemplateIcon(props: React.HTMLAttributes<SVGSVGElement>) {
  return <Image className="p-2" width={100} height={48} {...props} />;
}
